import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnboardingPageService } from '../onboarding-page/onboarding-page.service';
import { VehicleModelsService } from './vehicle-models.service';
import { DataService } from '../data.service';
import { ConstantsService } from '../constants.service';
import { ToastMessage } from '../toast-message/toast-message.service';

@Component({
  selector: 'app-vehicle-model-create',
  template: require('./vehicle-model-create.component.html')
})
export class VehicleModelCreateComponent implements OnInit {
  manufacturer: string = '';
  model: string = '';
  displayName: string = '';
  modeId: string = '';
  modes: Array<{ _id: string, mode: string }> = [];
  type: string = '';
  typeOptions: string[] = [];
  active: boolean = true;

  constructor(private route: ActivatedRoute, private router: Router, private onboardingService: OnboardingPageService, private vehicleModelsService: VehicleModelsService, private dataService: DataService, private constantService: ConstantsService, private toast: ToastMessage) {}

  ngOnInit() {
    const qpModeId = this.route.snapshot.queryParamMap.get('modeId');
    this.modeId = qpModeId || '';
    this.loadModes();
    this.recomputeTypeOptions();
  }

  onBack() {
    this.router.navigate(['/vehicle-models'], { queryParamsHandling: 'preserve' });
  }

  onModeChange() {
    this.recomputeTypeOptions();
  }

  canSubmit(): boolean {
    const hasVal = (s: string) => !!(s && s.trim().length);
    const basicOk = hasVal(this.manufacturer) && hasVal(this.model) && hasVal(this.displayName) && hasVal(this.modeId);
    const typeOk = this.typeOptions.length ? hasVal(this.type) : true;
    return !!(basicOk && typeOk);
  }

  onSubmit() {
    if (!this.canSubmit()) { return; }
    // Auth check for add on action
    const addRole = this.constantService.vehicleModelPermissions.add;
    if (!this.userHasRole(addRole)) {
      this.toast.openSnackBarError('You are not authorized to add vehicle models');
      return;
    }
    const payload: any = {
      manufacturer: this.manufacturer,
      model: this.model,
      displayName: this.displayName,
      modeId: this.modeId,
      active: this.active ? true : false
    };
    if (this.typeOptions.length && this.type && this.type.trim().length) {
      payload.bodyType = this.type;
    }
    this.vehicleModelsService.createVehicleModel(payload).subscribe(
      (res: any) => {
        if (res && res.success) {
          this.router.navigate(['/vehicle-models'], { queryParamsHandling: 'preserve' });
        }
      },
      () => {}
    );
  }

  private recomputeTypeOptions() {
    const found = this.modes.find(function(m) { return m._id === (typeof ("" + (this.modeId || '')) === 'string' ? this.modeId : ''); }.bind(this));
    const modeName = (found && found.mode ? found.mode : '').toLowerCase();
    if (modeName === 'bike') {
      this.typeOptions = ['scooty', 'Bike'];
      if (this.typeOptions.indexOf(this.type) === -1) {
        this.type = '';
      }
    } else if (modeName === 'car') {
      this.typeOptions = ['Hatchback', 'Sedan', 'SUV','Compact SUV'];
      if (this.typeOptions.indexOf(this.type) === -1) {
        this.type = '';
      }
    } else if (modeName === 'auto') {
      this.typeOptions = ['E-rickshaw', 'Auto Rickshaw'];
      if (this.typeOptions.indexOf(this.type) === -1) {
        this.type = '';
      }
    } else {
      this.typeOptions = [];
      this.type = '';
    }
  }

  private loadModes() {
    let userId = localStorage.getItem('userId') || '';
    if (!userId) {
      const cookies = document.cookie.split(';');
      const idCookie = cookies.find(function(c) { return c.indexOf('_id') !== -1; });
      if (idCookie) {
        const parts = idCookie.split('=');
        if (parts.length > 1) {
          try {
            const raw = parts[1].trim();
            const parsed = JSON.parse(raw);
            if (parsed && parsed._id) {
              userId = String(parsed._id);
            } else {
              userId = raw;
            }
          } catch (_e) {
            userId = parts[1].trim();
          }
        }
      }
    }
    if (!userId) { return; }
    this.onboardingService.getModes(userId).subscribe(
      (resp: any) => {
        const data = resp && resp['data'] && resp['data']['modes'] && resp['data']['modes']['data'];
        if (data && data.forEach) {
          const mapped: Array<{ _id: string, mode: string }> = [];
          for (let i = 0; i < data.length; i++) {
            const m = data[i];
            mapped.push({ _id: m._id, mode: (m.mode || m.name || '') });
          }
          this.modes = mapped;
          this.recomputeTypeOptions();
        }
      },
      () => {}
    );
  }

  private userHasRole(role: string): boolean {
    const accessRoles = this.dataService.accessCookie('accessRoles') || '';
    const roles = accessRoles ? accessRoles.split(',') : [];
    return Array.isArray(roles) && roles.indexOf(role) > -1;
  }
}


